module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Two-bottles-db1d37eab3fc6f5cecb67ca585021c50.svg";